import React, { useState } from 'react';
import './style.scss';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import TabsCarousel from './shared/carousel';
import TabsDropdown from './shared/dropdown';
import { withTranslation } from 'react-i18next';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import VerticalTabItems from './shared/VerticalTabItems';

const TabsContainer = (props) => {
  const { heading, items } = props?.fields;
  const isEliteTheme = props?.fields?.IsEliteTheme?.value;

  const getTabName = (item) => ({ id: item?.id, name: item?.fields?.title?.value } || {});
  const firstTabName = getTabName(items[0]);

  const [activeTabName, setActiveTabName] = useState(firstTabName);
  if (!props?.fields || !props.params) return <GenericPlaceholder componentName="TabsContainer" />;
  var defaultOrientation = props?.params?.orientation?.toLowerCase() || 'horizontal';

  return (
    <div
      className={clsx(
        'content',
        'tabs-component',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        props?.params?.Styles
      )}
    >
      {heading?.value && (
        <div className="tabs-component-title">
          <Text field={heading} />
        </div>
      )}
      <div
        className={clsx('group-tabs', defaultOrientation === 'vertical' && 'group-tab-vertical')}
      >
        {defaultOrientation === 'vertical' && (
          <VerticalTabItems
            onTabClick={(name) => setActiveTabName(name)}
            initialTabName={activeTabName}
            tabNames={items.map((item) => getTabName(item))}
            className="search-categories tabs-component-pc"
            lang={props.i18n.language}
          />
        )}

        {defaultOrientation === 'horizontal' && (
          <TabsCarousel
            onTabClick={(name) => setActiveTabName(name)}
            initialTabName={activeTabName}
            tabNames={items.map((item) => getTabName(item))}
            className="tabs-component-pc"
            lang={props.i18n.language}
          />
        )}
        <TabsDropdown
          onTabClick={(name) => setActiveTabName(name)}
          activeTabName={activeTabName}
          tabNames={items.map((item) => getTabName(item))}
          className="tabs-component-mobile"
        />
        <Placeholder
          name="jss-tabContainer"
          rendering={props.rendering}
          activeTabName={activeTabName}
          sub={true}
        />
      </div>
    </div>
  );
};

export default withTranslation()(TabsContainer);
